module.exports = __webpack_public_path__ + "img/pollution_level_4.6e299bbb.png";